import { SourcingService } from 'api-clients/monolith';

import { QueryParams } from '@/hooks/use-filter-query';

export function getEnabledChannels(params: QueryParams) {
  return SourcingService.getInternalApiSourcingSourcingChannelsEnabledChannels(
    params.query,
  );
}
